"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateKeysSchema = exports.superKeySchema = exports.zodKeys = void 0;
const zod_1 = require("zod");
const util_1 = require("./schemas/util");
/**
 * Taken from https://github.com/colinhacks/zod/discussions/2134
 * Extracts all keys from a Zod schema, flattening nested objects and arrays to strings e.g:
 * @returns {string[]} All keys in the schema, flattened e.g. ['event.event_id', 'event.name']
 */
const zodKeys = (schema) => {
    if (schema instanceof zod_1.z.ZodNullable || schema instanceof zod_1.z.ZodOptional)
        return (0, exports.zodKeys)(schema.unwrap());
    if (schema instanceof zod_1.z.ZodArray)
        return (0, exports.zodKeys)(schema.element);
    if (schema instanceof zod_1.z.ZodObject)
        return Object.entries(schema.shape).flatMap(([key, value]) => {
            const nested = (0, exports.zodKeys)(value).map(subKey => `${key}.${subKey}`);
            return nested.length ? nested : key;
        });
    return [];
};
exports.zodKeys = zodKeys;
const superKeySchema = (keyPrefix) => zod_1.z
    .string()
    .startsWith(`${keyPrefix}.`)
    .regex(/^[a-zA-Z0-9_.]+$/);
exports.superKeySchema = superKeySchema;
const refineAggregates = (schema, keys, aggregatesPrefix) => schema.refine(val => new RegExp(aggregatesPrefix).test(val) ? new RegExp(`${aggregatesPrefix}\..+`).test(val) : keys.includes(val), {
    message: `field must be one of:
  ${keys.join(', \n  ')}.
  aggregates must be a string of the form "${aggregatesPrefix}.<metric_name>"`,
});
const aggregateKeysSchema = (schema, aggregatesPrefix) => {
    const schemaWithoutAggregates = schema.omit({ aggregates: true });
    return refineAggregates(zod_1.z.union([...(0, util_1.schemaKeys)(schemaWithoutAggregates), (0, exports.superKeySchema)(aggregatesPrefix)]), (0, exports.zodKeys)(schemaWithoutAggregates), aggregatesPrefix);
};
exports.aggregateKeysSchema = aggregateKeysSchema;
//# sourceMappingURL=util.js.map